import { createContext } from "react"

const AccessOpeningContext = createContext();

export default AccessOpeningContext;